<template>
  <div class="decade">
    <div
      class="decade-weeks"
    >
      <square
        v-for="n in 520"
        :key="n"
        :enabled="n <= weeksPassed"
        :class="{'decade-break': n % 26 === 0 && n % 52 !== 0}"
      />
    </div>

    <div class="line-numbers">
      <span />
      <span>{{ (decadeNum - 1) * 10 + 5 }}</span>
      <span>{{ (decadeNum - 1) * 10 + 10 }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Square from '@/components/Square.vue'

export default defineComponent({
  name: 'Decade',

  components: {
    Square
  },

  props: {
    decadeNum: {
      type: Number,
      default: 0
    },

    weeksPassed: {
      type: Number,
      default: 0
    }
  }
})
</script>

<style scoped>
  .decade {
    display: flex;
  }

  .decade-weeks {
    display: grid;
    grid-template-columns: repeat(52, auto);
    row-gap: 4px;
    column-gap: 4px;
  }

  .line-numbers {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 6px;
  }

  .decade-break {
    margin-right: 20px;
  }

  @media screen and (max-width: 800px) {
    .decade-weeks {
      grid-template-columns: repeat(13, auto);
      column-gap: 12px;
    }

    .line-numbers {
      margin-left: 0;
    }

    .decade-break {
      margin-right: 8px;
    }
  }
</style>
